import React, { Component } from "react";
import EnterpriseInformationDeliveryListItem from "./DeliveryItem";
import Busines from "../../../models/business";
import {
    Modal,
    ModalBody,
    ModalHeader,
    Button
} from 'reactstrap';
import EnterpriseInformationDeliveryForm from "./DeliveryForm";


class EnterpriseInformationDeliveryList extends Component{
    constructor(props){
        super(props);

        this.loadData = this.loadData.bind(this);
        this.toggleAddressModal = this.toggleAddressModal.bind(this);
        this.onAddressAdded = this.onAddressAdded.bind(this);

        this.state = {
            loading: false,
            addresses: [],
            add_address_shown: false
        };
    }

    componentDidMount(){
        this.loadData();
    }

    loadData(){
        this.setState({loading: true, addresses: []});

        Busines.getAddresses(results => {
            this.setState({
                loading: false,
                addresses: results
            });
        });
    }

    toggleAddressModal(){
        this.setState({add_address_shown: !this.state.add_address_shown});
    }

    onAddressAdded(){
        setTimeout(this.toggleAddressModal, 1000);
        this.loadData();
    }

    render(){
        return (
            <div>
                <div className="d-flex justify-content-between pad-b-10">
                    <h2 className="ty-subtitle">Vos adresses de livraison</h2>

                    <div>
                        <Button color="primary" className="text-uppercase btn-xs" onClick={this.toggleAddressModal}>
                            <i className="icon icon-plus marg-r-10"> </i> Ajouter
                        </Button>
                    </div>
                </div>

                <div className="ty-block">
                    {
                        this.state.loading ?
                            <div className="center">
                                <i className="icon icon-loading animated spin infinite f-20"> </i>
                            </div>
                            :
                            (
                                this.state.addresses.length === 0 ? "Aucune adresse enregistrée"
                                    :
                                    this.state.addresses.map((address, i) => {
                                        return <EnterpriseInformationDeliveryListItem
                                            key={i}
                                            address={address}
                                            onAddressRemoved={this.loadData}
                                            onAddressUpdated={this.loadData}
                                        />
                                    })
                            )
                    }
                </div>

                <Modal isOpen={this.state.add_address_shown} toggle={this.toggleAddressModal}>
                    <ModalHeader toggle={this.toggleAddressModal}>Ajouter une adresse de livraison</ModalHeader>
                    <ModalBody>
                        <EnterpriseInformationDeliveryForm onAddressAdded={this.onAddressAdded} />
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

EnterpriseInformationDeliveryList.defaultProps = {

};

export default EnterpriseInformationDeliveryList;



// WEBPACK FOOTER //
// ./src/components/Enterprise/Information/DeliveryList.js